import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { RouteLocations } from './RouteLocations';
import {
  UserProvider,
  CreateExperiment,
  EdaConfig,
  ExperimentDesign,
  ExperimentSummary,
  MarketInsights,
  MatchedMarkets,
  PowerAnalysis,
  Help,
} from '@mightyhive/gridmodule';


// Command Center was folded into the EDA config step. `<Navigate to>` resolves its
// target verbatim, so the redirect has to read :id itself rather than embed the
// placeholder in the path. The fallback only exists to narrow useParams' optional
// type -- `:id` never matches an empty segment, so bare /grid/command-center is
// handled by its own route below, not here.
function RedirectCommandCenterToEda(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `../eda-config/${id}` : '../create-experiment'} replace />;
}

export function Grid(): JSX.Element {
  const { email, selectedClientExternalUuid } = useUser();

  return (
    <UserProvider initialEmail={email}>
      <Routes>
        {/* Relative targets resolve against the matched route's own base, so the
            leading `..` below is load-bearing. The index route needs no `..`
            because an index route contributes no path segment and so resolves
            against /grid directly -- do not "normalize" these to match. */}
        <Route index element={<Navigate to="create-experiment" replace />} />
        <Route path="command-center" element={<Navigate to="../create-experiment" replace />} />
        <Route path="command-center/:id" element={<RedirectCommandCenterToEda />} />
        <Route path="create-experiment" element={<CreateExperiment selectedClientExternalUuid={selectedClientExternalUuid} />} />
        <Route path="eda-config" element={<Navigate to="../create-experiment" replace />} />
        <Route path="eda-config/:id" element={<EdaConfig />} />
        <Route path="experiment-design" element={<Navigate to="../create-experiment" replace />} />
        <Route path="experiment-design/:id" element={<ExperimentDesign />} />
        <Route path="market-insights" element={<MarketInsights />} />
        <Route path="market-insights/:id" element={<MarketInsights />} />
        <Route path="matched-markets" element={<MatchedMarkets />} />
        <Route path="matched-markets/:id" element={<MatchedMarkets />} />
        <Route path="power-analysis" element={<PowerAnalysis />} />
        <Route path="power-analysis/:id" element={<PowerAnalysis />} />
        <Route path="experiment-summary" element={<ExperimentSummary />} />
        <Route path="experiment-summary/:id" element={<ExperimentSummary />} />
        <Route path="results-library" element={<Navigate to={RouteLocations.LIBRARY} replace />} />
        <Route path="help" element={<Help />} />
      </Routes>
    </UserProvider>
  );
}
